import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Login from './Auth/Login'
import Logout from './Auth/Logout';
import Dashboard from './Dashboard';

function App() {
  const isAuthenticated = !!localStorage.getItem('token');

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/Logout" element={<Logout />} />
        <Route path="/" element={isAuthenticated ? <Dashboard /> : <Login />} />
      </Routes>
    </Router>
  )
}

export default App;
